import React from 'react';
import {
  Card, CardBody, Row, Col, CardHeader,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { PercentageCircle, PercentageBar, AccountStatus } from '../../../index';

export default function AccountProfileCard({ account }) {
  let percentageBarColor;
  if (account.AccountCurrentProfileRisk === account.AccountProfileRisk) {
    // Tiene el mismo riesgo teórico que práctico
    percentageBarColor = 'green';
  } else if (account.AccountCurrentProfileRiskPercentage > account.AccountProfileRiskPercentage) {
    percentageBarColor = 'red';
  } else {
    percentageBarColor = 'orange';
  }

  let accountStatus = account.AccountStatus;
  if (account.AccountStatus === AccountStatus.BLOCKED
    && account.AccountIsExceptionallyUnblocked) {
    const localDate = new Date(`${account.AccountUnblockingEndTime}Z`);
    const localTimeString = localDate.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
    });
    accountStatus = `Active until ${localTimeString}`;
  }

  const cardHeight = account.AccountName.length > 140 ? 300 : 245;

  return (
    <Card style={{ height: cardHeight }}>
      <CardHeader>{`${account.AccountName} (${account.AccountNumber})`}</CardHeader>
      <CardBody>
        <Row>
          <Col className="text-center">
            <Row style={{ marginTop: 5 }}>
              <div style={{
                zIndex: 1, position: 'absolute', top: '34px', left: '121px',
              }}
              >
                <PercentageBar currentPercentage={account.AccountCurrentProfileRiskPercentage} fixedMarkerPercentage={account.AccountProfileRiskPercentage} fixedMarkerText="Profile Risk" barColor={percentageBarColor} />
              </div>
              <div style={{
                zIndex: 2, position: 'absolute', left: '10px',
              }}
              >
                <PercentageCircle descriptionText="HEALTH" percentage={Math.round(account.AccountHealthPercentage)} color="green" />
              </div>
              <div style={{
                position: 'absolute', top: '67px', left: '140px', textAlign: 'left',
              }}
              >
                <span>Status: </span>
                <span>{accountStatus}</span>
                <br />
                <span>Email: </span>
                <span>{account.AccountEmail}</span>
                <br />
                <span>Address: </span>
                <span>{`${account.AccountShippingAddresStateName} ${account.AccountShippingAddresCityName}, ${account.AccountShippingAddresCountryName}`}</span>
              </div>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

AccountProfileCard.propTypes = {
  account: PropTypes.object.isRequired,
};
